import { render, staticRenderFns } from "./CompressionConfig.vue?vue&type=template&id=7f072063&scoped=true"
import script from "./CompressionConfig.vue?vue&type=script&lang=js"
export * from "./CompressionConfig.vue?vue&type=script&lang=js"
import style0 from "./CompressionConfig.vue?vue&type=style&index=0&id=7f072063&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f072063",
  null
  
)

export default component.exports